import { TypingEffect } from "@/components/TypingEffect";
import { motion } from "framer-motion";

interface SpeechBubbleProps {
    text: string;
    animationDelay?: number;
    onTypingComplete?: () => void;
}

export const SpeechBubble = ({ text, onTypingComplete, animationDelay = 0 }: SpeechBubbleProps) => {
    const inAnimationDuration = 0.3;
    return (
        <motion.div
            initial={{ opacity: 0, scale: 0.5 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: inAnimationDuration, delay: animationDelay }}
            className="bg-white border-2 border-osGrey-4 rounded-xl p-4 relative max-w-[90%] w-fit text-osBlack font-semibold text-balance text-center text-sm">
            <TypingEffect text={text} initialDelay={inAnimationDuration + animationDelay} onComplete={onTypingComplete} />
        </motion.div>
    );
};